import { Injectable } from '@angular/core';
import { NotificationType } from 'angular2-notifications';
import { NodeInstanceModel } from '../../../models/node/node-instance.model';
import { AlertService } from '../../../services/alert.service';
import { FieldHelper } from '../../../services/helpers/field.helper';

interface DateChangeParams {
  rawValue: Date | string | null;
  fieldId: string;
  dueDateFieldId: string;
  startDateFieldId: string;
  selectedNode: NodeInstanceModel | null | undefined;
  formData: { [fieldId: string]: any };
  validationMessage: string;
}

@Injectable({
  providedIn: 'root',
})
export class EditPanelDateHelperService {
  constructor(
    private alertService: AlertService,
    private fieldHelper: FieldHelper,
  ) {}

  public handleCalendarDateChange(params: DateChangeParams): Date | null {
    if (!params) {
      return null;
    }
    if (!params.rawValue || !params.fieldId) {
      return null;
    }
    const selectedDate = this.parseDate(params.rawValue);
    if (isNaN(selectedDate.getTime())) {
      return null;
    }

    const isDueDateField = params.fieldId === params.dueDateFieldId;
    const isStartDateField = params.fieldId === params.startDateFieldId;

    if (isDueDateField || isStartDateField) {
      const startDateValue = this.getNodeDateValue(params.selectedNode, params.startDateFieldId);
      const dueDateValue = this.getNodeDateValue(params.selectedNode, params.dueDateFieldId);

      if (isDueDateField && startDateValue && selectedDate < startDateValue) {
        this.handleValidationError(params, dueDateValue);
        return null;
      }

      if (isStartDateField && dueDateValue && selectedDate > dueDateValue) {
        this.handleValidationError(params, startDateValue);
        return null;
      }
    }

    params.formData[params.fieldId] = selectedDate;
    return selectedDate;
  }

  private parseDate(value: Date | string): Date {
    return value instanceof Date ? new Date(value.getTime()) : new Date(value);
  }

  private getNodeDateValue(node: NodeInstanceModel | null | undefined, fieldId: string): Date | null {
    if (!node || !fieldId) {
      return null;
    }
    const fieldValue = this.fieldHelper.getFieldValue(node, fieldId) as string | undefined;
    if (!fieldValue) {
      return null;
    }
    const parsed = new Date(fieldValue);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private handleValidationError(params: DateChangeParams, revertValue: Date | null): void {
    this.alertService.alert(NotificationType.Error, params.validationMessage, true);
    params.formData[params.fieldId] = revertValue;
  }
}
